import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import SponsorCardSettings from "@/components/editor/shared/sponsors/sponsor-card/sponsor-card-settings-component";
import type { SponsorCardProps } from "@/components/editor/shared/sponsors/sponsors-settings/sponsors-settings-component";

import {
  CardContainer,
  CardContent,
  Logo,
  SponsorCardLink,
  StyledSponsorCard,
} from "./sponsor-card-component-styles";

export default function SponsorCard({ sponsor }: SponsorCardProps) {
  const {
    connectors: { connect },
  } = useNode();
  const { t } = useTranslation();
  const { enabled } = useEditor((state) => ({
    enabled: state.isEnabled(),
  }));

  return (
    <StyledSponsorCard data-testid="sponsor-card" ref={connect}>
      <CardContainer>
        <SponsorCardLink
          target="_blank"
          rel="sponsored"
          data-testid="sponsor-card-link"
          aria-label={`${sponsor.name} ${t("common.website")} (${t(
            "common.opens-in-new-window"
          )})`}
          href={enabled ? null : sponsor.website}
        >
          <CardContent>
            <Logo
              data-testid="sponsor-card-logo"
              src={sponsor.image_url}
              alt={sponsor.name}
              draggable="false"
            />
          </CardContent>
        </SponsorCardLink>
      </CardContainer>
    </StyledSponsorCard>
  );
}

SponsorCard.craft = {
  custom: {
    displayName: "Sponsor Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: SponsorCardSettings,
  },
};
